/** Cross-client upload policy. Sizes use binary MiB. */
export const MIB = 1024 * 1024;
export const ASSET_MAX_BYTES = 10 * MIB;
export const CHAT_FILE_MAX_BYTES = 50 * MIB;
const LEGACY_ONLINE_FILE_MAX_BYTES = 50 * MIB;
const LEGACY_OFFLINE_FILE_MAX_BYTES = 10 * MIB;
export const ARTICLE_MAX_IMAGES = 9;
export const ARTICLE_MAX_VIDEOS = 1;

export function assetSizeError(sizeBytes: number): string | null {
  return sizeBytes > ASSET_MAX_BYTES
    ? '图片、视频、音频和普通附件不能超过 10 MiB，请选择更小的文件'
    : null;
}

export function chatFileSizeError(sizeBytes: number): string | null {
  return sizeBytes > CHAT_FILE_MAX_BYTES
    ? '聊天文件不能超过 50 MiB，请选择更小的文件'
    : null;
}

/** Limits for legacy non-chat P2P/offline transfer APIs; chat attachments use chatFileSizeError. */
export function legacyFileSizeError(sizeBytes: number, offline: boolean): string | null {
  const maxBytes = offline ? LEGACY_OFFLINE_FILE_MAX_BYTES : LEGACY_ONLINE_FILE_MAX_BYTES;
  return sizeBytes > maxBytes ? '文件超过旧版传输通道限制' : null;
}
